import { FeatureRadio } from '@praetorian-chariot/ui';

import { SeedTypeOption } from '@/types';

const seedTypeOptions = [
  {
    id: SeedTypeOption.DOMAIN_CIDR,
    title: 'Network Assets',
    description:
      'Add domain names, IP addresses, and CIDR ranges for network scanning',
  },
  {
    id: SeedTypeOption.WEB_APPLICATION,
    title: 'Web Applications',
    description: 'Add web application URLs for security testing',
  },
  {
    id: SeedTypeOption.WEB_SERVICE,
    title: 'Web Services',
    description: 'Add web service endpoints ',
  },
];

interface SeedTypeSelectorProps {
  value: SeedTypeOption | null;
  onChange: (type: SeedTypeOption) => void;
}

export const SeedTypeSelector = ({
  value,
  onChange,
}: SeedTypeSelectorProps) => {
  return (
    <div className="flex flex-col gap-4">
      <h3 className="text-lg font-bold">Select Seed Type</h3>
      {seedTypeOptions.map(option => (
        <FeatureRadio
          key={option.id}
          id={option.id}
          checked={value === option.id}
          title={option.title}
          description={option.description}
          onChange={() => onChange(option.id)}
        />
      ))}
    </div>
  );
};
